import request from '../utils/request.js'

// 获取分类列表
export function findMenu () {
  return request({
    url: '/api/v1/admin/findMenu',
    method: 'get'
  })
}

// 新增/编辑分类
export function createMenu (data) {
  return request({
    url: '/api/v1/admin/createMenu',
    method: 'post',
    data
  })
}

// 删除分类（仅支持单个）
export function deleteMenu (id) {
  return request({
    url: '/api/v1/admin/deleteMenu',
    method: 'post',
    data: [id]
  })
}

// 分类图片上传
export function uploadCategoryImage (formData) {
  return request({
    // 复用后端公共图片上传
    url: '/api/v1/upload/image',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}




// WEBPACK FOOTER //
// ./src/api/menu.js